import type { TpTenant } from "@/app/services/generated/tradeportalService";
import type { Framework } from "vuetify";

function colourToVuetify(colour: string) {
  //Vuetify seems to only like #rrggbb format values.
  if (colour.startsWith("#") && colour.length === 9) {
    // Have been provided with #rrggbbaa - trim the aa
    return colour.substring(0, 7);
  }
  return colour;
}

function loadGoogleFonts(brandFont: string, bodyFont: string) {
  const fonts = [brandFont, bodyFont].filter((x) => x);

  if (fonts.length > 0) {
    const fontString = fonts.map((font) => font.replace(/ /g, "+")).join("|");

    const existingLinks = document.querySelectorAll(
      'link[rel="stylesheet"][data-google-font]'
    );
    existingLinks.forEach((link) => link.remove());

    const link = document.createElement("link");
    link.href = `https://fonts.googleapis.com/css?family=${fontString}&display=swap`;
    link.rel = "stylesheet";
    link.setAttribute("data-google-font", "true");

    document.head.appendChild(link);

    const app = document.getElementById("app");
    if (app && bodyFont) {
      app.style.fontFamily = bodyFont;
    }
  }
}

export class TpBranding {
  private _primaryBg = "rgb(40, 40, 120)";
  private _primaryFg = "rgb(255, 255, 255)";
  private _secondaryBg = "rgb(47, 128, 203)";
  private _secondaryFg = "rgb(255, 255, 255)";
  private _brandFont = "";
  private _bodyFont = "";

  public get primaryBg() {
    return this._primaryBg;
  }
  public get primaryFg() {
    return this._primaryFg;
  }

  public get secondaryBg() {
    return this._secondaryBg;
  }
  public get secondaryFg() {
    return this._secondaryFg;
  }

  public get premierSystemsBrandBg() {
    return "rgb(0, 46, 93)";
  }

  public get premierSystemsBrandFg() {
    return "rgb(255, 255, 255)";
  }

  public get surfaceFg() {
    return "rgba(28, 27, 27)";
  }

  public get surfaceVariantBg() {
    return "rgb(243, 243, 243)";
  }

  public get surfaceVariantFg() {
    return "rgb(103, 103, 103)";
  }

  public get inBasketBg() {
    return "rgb(169, 224, 123)";
  }

  public get pageBg() {
    return "rgb(255, 255, 255)";
  }

  public get pageFg() {
    return "rgb(0, 0, 0)";
  }

  public get warningBannerBg() {
    return "rgb(252, 242, 222)";
  }
  public get warningTriangleColour() {
    return "rgb(255, 187, 50)";
  }

  public get errorFg() {
    return "rgb(228, 0, 0";
  }

  public get errorBannerBg() {
    return "rgb(252, 222, 222)";
  }

  public get successFg() {
    return "rgb(0, 128, 0";
  }

  public get successBannerBg() {
    return "rgb(222, 252, 222)";
  }

  public get brandFont() {
    return this._brandFont;
  }
  public get bodyFont() {
    return this._bodyFont;
  }

  public setTenantBranding(tenant: TpTenant, vuetify: Framework) {
    if (tenant.brandColour) {
      this._primaryBg = tenant.brandColour;
      vuetify.theme.themes.light.primary = colourToVuetify(tenant.brandColour);
    }

    if (tenant.onBrandColour) {
      this._primaryFg = tenant.onBrandColour;
    }

    if (tenant.secondaryColour) {
      this._secondaryBg = tenant.secondaryColour;
      vuetify.theme.themes.light.secondary = colourToVuetify(
        tenant.secondaryColour
      );
    }

    if (tenant.onSecondaryColour) {
      this._secondaryFg = tenant.onSecondaryColour;
    }

    if (tenant.brandFont) {
      this._brandFont = tenant.brandFont;
    }

    if (tenant.bodyFont) {
      this._bodyFont = tenant.bodyFont;
    }

    loadGoogleFonts(this._brandFont, this._bodyFont);
  }
}

const tpBranding = new TpBranding();

export { tpBranding };
